import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import panelApi from "@/lib/panelApi";
import api, { getBaseId } from "@/lib/api";

export const usePayBases = () =>
  useQuery({ queryKey: ["panel-pay-bases"], queryFn: async () => (await panelApi.get("/panel/pay-bases")).data?.values || {} });

// Administrativo com base de pagamento em outra base: não gera folha/benefícios na base selecionada.
export const useOutOfPayBase = () => {
  const { data: map, isSuccess } = usePayBases();
  const collabs = useQuery({ queryKey: ["all-collabs-nobase"], queryFn: async () => (await api.get("/admin/collaborators", { skipBaseId: true })).data?.collaborators || [] });
  const base = getBaseId();
  const fn = useCallback((uid) => {
    if (!base || !map?.[uid] || map[uid] === base) return false;
    return (collabs.data || []).find((c) => c.id === uid)?.role === "funcionario";
  }, [base, map, collabs.data]);
  fn.ready = isSuccess && collabs.isSuccess;
  return fn;
};

// Administrativo com base de pagamento definida só entra na folha/custo dessa base.
export const filterPayrollByPayBase = (data, map, base = getBaseId()) => {
  if (!data?.payroll?.lines || !base || !map) return data;
  const lines = data.payroll.lines.filter((l) => !(l.role === "funcionario" && map[l.user_id] && map[l.user_id] !== base));
  return lines.length === data.payroll.lines.length ? data : { ...data, payroll: { ...data.payroll, lines } };
};
